<div class="se-fullscreen" [class.fullscreen-mode]="fullscreen">
    <img [hidden]="!enableFullscreenMode" class="se-image-fullscreen" alt="Toggle fullscreen" [src]="fullscreen ? 'assets/images/ZoomOut.png' : 'assets/images/ZoomIn.png'" (click)="onFullScreenToggle()" />
    <ng-content></ng-content>
</div>
